<template>
  <div>
    <HomeHeaderNavBar></HomeHeaderNavBar>
    <CompanyHeader></CompanyHeader>
    <CompanyIntroduction></CompanyIntroduction>
    <!-- <CompanyNews></CompanyNews> -->
    <CompanySpecialty
      :title="title"
      :des="des"
      :content="content"
    ></CompanySpecialty>
    <CompanyClient></CompanyClient>
    <!-- <CompanyContact></CompanyContact> -->
    <HomeFooter></HomeFooter>
    <!-- <Fixed></Fixed> -->
  </div>

</template>

<script>
import HomeHeaderNavBar from "../home/components/HeaderNavBar";
import CompanyHeader from "./components/ContentHeader";
import CompanyIntroduction from "./components/ContentIntroduction";
import CompanyNews from "./components/ContentNews";
import CompanySpecialty from "./components/ContentSpecialty";
import CompanyClient from "./components/ContentClient";
import CompanyContact from "./components/ContentContact";
import HomeFooter from "../home/components/Footer";
import Fixed from "@/pages/fixed";

export default {
  name: "Company",
  components: {
    HomeHeaderNavBar,
    CompanyHeader,
    CompanyIntroduction,
    CompanyNews,
    CompanySpecialty,
    CompanyClient,
    CompanyContact,
    HomeFooter,
    Fixed,
  },
  data() {
    return {
      title: "专业服务",
      des: "The professional services",
      content:
        "我们是一家集研发、销售、服务为一体的高新技术公司。专为工厂生产现场的人员、设备、质量、物流、安全、交付等生产环节管理提供信息化、智能化解决方案。",
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/company/Company.vue